import React from 'react';
import timbradoPhoto from '../../assets/images/photos/timbrado-colegas.jpg';
import './TimbradoPromoSection.css';

const benefitsList = [
  'Disponibilidad del 99.98%',
  'Servicio 24 x 7 x 365',
  'Máxima seguridad para tu información',
  'El servicio más rápido del mercado',
  'Resguardo de XML por 5 años',
  'Desarrollo de herramientas personalizadas',
  'Siempre actualizado a las disposiciones oficiales',
  'Reporte de timbrado por solicitud',
  'Y mucho más'
];

const TimbradoPromoSection = () => {
  const handleScrollToContact = (e) => {
    e.preventDefault();
    const contactEl = document.querySelector('#contacto');
    if (contactEl) {
      const headerOffset = 70;
      const elementPosition = contactEl.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="df-timbrado-promo-section">
      <div className="df-timbrado-promo-container">
        {/* Columna Izquierda: Contenido y Lista de Beneficios */}
        <div className="df-timbrado-promo-content">
          <h2 className="df-timbrado-promo-title">
            Timbra tus facturas con <strong>Digital Factura</strong>
          </h2>

          <p className="df-timbrado-promo-desc">
            Si ya generas el XML v3.3, tan sólo contrata tu paquete de timbrado y nosotros te damos toda la asesoría gratuita para realizar el enlace a nuestro web service de timbrado.
          </p>

          <div className="df-timbrado-benefits-grid">
            {benefitsList.map((benefit, idx) => (
              <div key={idx} className="df-timbrado-benefit-item">
                <span className="df-timbrado-check-badge" aria-hidden="true">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <path d="m5 12 5 5 9-10"></path>
                  </svg>
                </span>
                <span className="df-timbrado-benefit-text">{benefit}</span>
              </div>
            ))}
          </div>

          <a
            href="#contacto"
            className="df-timbrado-btn-cta"
            onClick={handleScrollToContact}
          >
            Contrata tu paquete de timbrado
          </a>
        </div>

        {/* Columna Derecha: Composición Visual con Arco Rojo y Fotografía */}
        <div className="df-timbrado-promo-visual">
          <div className="df-timbrado-promo-arch-wrapper">
            {/* Silueta / Fondo Rojo Arqueado */}
            <div className="df-timbrado-promo-arch-bg" aria-hidden="true"></div>

            {/* Fotografía Arqueada de Colegas */}
            <img
              src={timbradoPhoto}
              alt="Colegas revisando información en la computadora"
              className="df-timbrado-promo-arch-img"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TimbradoPromoSection;
